/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TypeDocumentation
 */
export interface TypeDocumentation {
    /**
     * 
     * @type {string}
     * @memberof TypeDocumentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TypeDocumentation
     */
    url: string;
}

export function TypeDocumentationFromJSON(json: any): TypeDocumentation {
    return TypeDocumentationFromJSONTyped(json, false);
}

export function TypeDocumentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeDocumentation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'url': json['url'],
    };
}

export function TypeDocumentationToJSON(value?: TypeDocumentation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'url': value.url,
    };
}


